import React from "react";
import ProjectDiv from "./ProjectDiv";

function ProjectSection() {
  const projOne = {
    link: "https://chit-chats.vercel.app/",
    pic: "Project-Chit-Chat-Pic.jpeg",
    title: "Chit Chat",
    dis: "Your hub for anonymous chats, limitless chat rooms, and easy media sharing.",
    techOne: "Node. js",
    techTwo: "Socket. io",
  };

  const projTwo = {
    link: "https://urls-shortner.vercel.app/",
    pic: "Project-URL-Shortner-Pic.jpeg",
    title: "URL Shortner",
    dis: "Transforming Long Links into Snappy Shortcuts.",
    techOne: "React. js",
    techTwo: "Node. js",
  };

  const projThree = {
    link: "https://filmstar-app.web.app/",
    pic: "Project-Filmstar-Pic.jpeg",
    title: "Filmstar",
    dis: "Web-app which lists movies and web-series with Firebase-auth",
    techOne: "React. js",
    techTwo: "Redux",
  };

  return (
    <section id="projects" className="project-section">
      <div className="project-text-heading container">
        <h2>A Selection Of Stuffs I've Built.</h2>
      </div>
      <div className="project-text-content container">
        <p className="project-text">
          I've developed many projects but these are my recent projects chosen
          by me. I've done them altogether from design to code.
        </p>
        <div className="project-grid">
          <ProjectDiv {...{ ...projOne }} />
          <ProjectDiv {...{ ...projTwo }} />
          <ProjectDiv {...{ ...projThree }} />
        </div>
      </div>
    </section>
  );
}

export default ProjectSection;
